import { render, staticRenderFns } from "./SparePartsDetailModal.vue?vue&type=template&id=b934bf84&"
import script from "./SparePartsDetailModal.vue?vue&type=script&lang=js&"
export * from "./SparePartsDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports